import React, { useContext, useEffect, useState } from 'react';
import {
  Input,
  Table,
  Row,
  Col,
  Card,
  Button,
  Modal,
  Form,
  Popconfirm
} from 'antd';
import { PageHeader } from '@ant-design/pro-components';
import {
  DeleteFilled,
  EditFilled,
  QuestionCircleOutlined
} from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';
import { observer } from 'mobx-react';
import { rootContext } from 'stores';
import { useDebouncedCallback } from 'use-debounce';

import { ILang } from 'stores/languages';
export type IFilterType = {
  [key: string]: string | null;
};

const Parts: React.FC = observer(() => {
  const {
    LanguageStore: {
      state: { data, ui },
      getLanguagesKeyWord,
      addNewLangaugeKeyword,
      deleteLangaugeKeyWord,
      updateLanguageKeyword,
      setState
    }
  } = useContext(rootContext);

  const [search, setSearch] = useState<string>('');
  const [showAddKeywordModal, setShowAddKeywordModal] = useState<boolean>(
    false
  );
  const [editForm] = Form.useForm();

  const { keywords, total, selectedRecord } = data;

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 }
  };

  const columns: ColumnsType<ILang> = [
    {
      title: 'Defaut(EN)',
      dataIndex: 'default',
      key: 'default',
      align: 'center'
    },
    {
      title: 'Chinese(ZH)',
      dataIndex: 'zh',
      key: 'zh',
      align: 'center'
    },

    {
      title: 'Russian(RU)',
      dataIndex: 'ru',
      key: 'ru',
      align: 'center'
    },
    {
      title: 'Japanese(JA)',
      dataIndex: 'ja',
      key: 'ja',
      align: 'center'
    },
    {
      title: 'Arabic(AR)',
      dataIndex: 'ar',
      key: 'ar',
      align: 'center'
    },
    {
      title: 'Actions',
      align: 'center',
      render: (value: any, record: ILang, index: number) => (
        <div className="actionButtons">
          <Button
            type="default"
            className="editButton"
            onClick={() => {
              const { createdAt, updatedAt, ...rest } = record;
              setState({ data: { ...data, selectedRecord: rest } });
              editForm.setFieldsValue(record);
              setShowAddKeywordModal(true);
            }}
          >
            <EditFilled />
          </Button>
          <Popconfirm
            title="Are you sure？"
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={async () => {
              await deleteLangaugeKeyWord(record);
              getLanguagesKeyWord();
            }}
          >
            <Button
              type="default"
              className="deleteButton"
              disabled={ui.getKeyWordsLoading}
            >
              <DeleteFilled />
            </Button>
          </Popconfirm>
        </div>
      )
    }
  ];

  const debounced = useDebouncedCallback(search => {
    getLanguagesKeyWord(search);
  }, 800);

  useEffect(() => {
    getLanguagesKeyWord(search);
  }, [getLanguagesKeyWord, search]);

  const validations = (rule: any, value: any, callback: any) => {
    if (value && value?.trim()?.length === 0) {
      return Promise.reject('Whitespaces are not valid.');
    } else {
      return Promise.resolve();
    }
  };
  return (
    <div className="PartsStyles">
      <div className="cardWrapeer">
        <Card>
          <PageHeader>
            <Row justify="space-between">
              <Col>
                <Input.Search
                  className="search_input_control"
                  loading={ui.getKeyWordsLoading}
                  allowClear
                  value={search}
                  onChange={e => {
                    setSearch(e.target.value);
                    debounced(e.target.value);
                  }}
                  placeholder="Search"
                />
              </Col>
              <Col>
                <Button
                  onClick={() => setShowAddKeywordModal(true)}
                  type="link"
                  className="primary_btn"
                >
                  Add Keyword
                </Button>
              </Col>
            </Row>
          </PageHeader>
          <Table
            className="Table_block_main"
            columns={columns}
            loading={ui.getKeyWordsLoading}
            dataSource={keywords}
            tableLayout="auto"
            rowKey="id"
            onChange={(pagination, _, sort) => {
              const { current = 1, pageSize = 10 } = pagination;
              getLanguagesKeyWord(search, pageSize, current);
            }}
            pagination={{
              disabled: ui.getKeyWordsLoading,
              total: total,
              pageSize: data.limit,
              current: data.offset,
              showSizeChanger: true,
              pageSizeOptions: ['10', '15', '20']
            }}
          />
        </Card>
        <Modal
          confirmLoading={ui.getKeyWordsLoading}
          visible={showAddKeywordModal}
          title={selectedRecord ? 'Edit Keyword' : 'Add Keyword'}
          onCancel={() => {
            setShowAddKeywordModal(false);
            setState({ data: { ...data, selectedRecord: null } });
            editForm.resetFields();
          }}
          onOk={editForm.submit}
          destroyOnClose={true}
        >
          <Form
            {...layout}
            form={editForm}
            onFinish={async values => {
              Object.keys(values).map(k => (values[k] = values[k]?.trim()));
              selectedRecord
                ? await updateLanguageKeyword({
                    id: selectedRecord.id,
                    ...values
                  })
                : await addNewLangaugeKeyword(values);
              setShowAddKeywordModal(false);
              setState({ data: { ...data, selectedRecord: null } });
              editForm.resetFields();
              getLanguagesKeyWord();
            }}
          >
            <Form.Item
              label="Default(EN) "
              key="default"
              name="default"
              rules={[
                { required: true, message: 'Default (en) is required' },
                { validator: validations }
              ]}
            >
              <Input required />
            </Form.Item>
            <Form.Item
              label="Chinese(ZH)"
              key="zh"
              name="zh"
              rules={[{ validator: validations }]}
            >
              <Input type="text" />
            </Form.Item>
            <Form.Item
              label="Russian(RU)"
              key="ru"
              name="ru"
              rules={[{ validator: validations }]}
            >
              <Input type="text" />
            </Form.Item>
            <Form.Item
              label="Japanese(JA)"
              key="ja"
              name="ja"
              rules={[{ validator: validations }]}
            >
              <Input type="text" />
            </Form.Item>
            <Form.Item
              label="Arabic(AR)"
              key="ar"
              name="ar"
              rules={[{ validator: validations }]}
            >
              <Input type="text" />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </div>
  );
});

export default Parts;
